import { Injectable } from '@angular/core';
import {
  DinteroCheckoutInstance,
  SessionCancel,
  SessionPaymentAuthorized,
  SessionPaymentError,
  SessionPaymentOnHold,
  embed,
} from '@dintero/checkout-web-sdk';

export interface IDinteroPaymentSession {
  paymentId?: number;
  sid: string;
  sessionId: string;
  url?: string;
}

export interface IDinteroInlineCheckoutOptions {
  snippedData: IDinteroPaymentSession;
  onPayment: (event: SessionPaymentAuthorized | SessionPaymentOnHold) => any;
  onError: (error: any) => any;
  onCancel: (event: SessionCancel) => any;
  containerToEmbed: HTMLDivElement;
  language?: string;
}

@Injectable()
export class DinteroCheckoutService {
  public createInlineCheckout(options: IDinteroInlineCheckoutOptions): Promise<DinteroCheckoutInstance> {
    const { snippedData, onPayment, onError, onCancel, containerToEmbed, language } = options;

    return embed({
      container: containerToEmbed,
      sid: snippedData.sessionId,
      language,
      onPayment: (event, checkout) => {
        onPayment(event);
        checkout.destroy();
      },
      onPaymentError: (event: SessionPaymentError, checkout) => {
        onError(event);
        checkout.destroy();
      },
      onSessionCancel: (event, checkout) => {
        onCancel(event);
        checkout.destroy();
      },
      onSessionNotFound: (event, checkout) => {
        onError(event);
        checkout.destroy();
      },
    }).catch((err) => {
      onError(err);
      throw err;
    });
  }

  public destroy(checkout: DinteroCheckoutInstance): void {
    if (checkout) {
      checkout.destroy();
    }
  }
}
